import React from "react";
import RoomCard from "./RoomCard";

const RoomsSection = ({ hotelRooms, selectedRooms, updateRoomQuantity, openRoomModal, guests, childAges, selectedDates, calculateNights, accommodationDetail, currentCurrency, onOpenLogin, isLoggedIn, memberDiscountPercent = 0 }) => {
  return (
    <div className="space-y-6">
      {hotelRooms.map((room, roomIndex) => (
        <RoomCard
          key={room.id}
          room={room}
          roomIndex={roomIndex}
          selectedRooms={selectedRooms}
          updateRoomQuantity={updateRoomQuantity}
          openRoomModal={openRoomModal}
          guests={guests}
          childAges={childAges}
          selectedDates={selectedDates}
          calculateNights={calculateNights}
          accommodationDetail={accommodationDetail}
          currentCurrency={currentCurrency}
          onOpenLogin={onOpenLogin}
          isLoggedIn={isLoggedIn}
          memberDiscountPercent={memberDiscountPercent}
        />
      ))}
    </div>
  );
};

export default RoomsSection;
